import React, { useEffect, useState } from "react";
import ProfilePopup from "./ProfilePopup";
import "./ProfileButton.css";

/**
 * A utility function to extract initials from a full name based on specific rules.
 * @param {string} fullName - The full name of the person.
 * @returns {string} The extracted initials.
 */
const getInitials = (fullName) => {
  // Handle empty or invalid input
  if (!fullName || typeof fullName !== "string") {
    return "";
  }

  // Split the name by spaces and filter out any empty strings
  const nameParts = fullName.trim().split(/\s+/).filter(Boolean);

  // Check the number of names
  if (nameParts.length >= 2) {
    // If 2 or more names, take the first and last
    const firstNameInitial = nameParts[0].charAt(0).toUpperCase();
    const lastNameInitial = nameParts[nameParts.length - 1]
      .charAt(0)
      .toUpperCase();
    return `${firstNameInitial}${lastNameInitial}`;
  } else if (nameParts.length === 1) {
    // If only one name, take the first initial of that name
    return nameParts[0].charAt(0).toUpperCase();
  }

  // Return an empty string if no valid name parts are found
  return "";
};

const ProfileButton = ({ isRecording }) => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    if (!isRecording) {
      setShowPopup(!showPopup);
    }
  };

  const [initials, setInitials] = useState(null);
  useEffect(() => {
    try {
      const rawName = sessionStorage.getItem("login_name");
      const name = rawName ? rawName.trim() : null;
      setInitials(getInitials(name));
    } catch {}
  }, []);

  return (
    <div className="profile-container">
      <div className="profile-button" onClick={togglePopup}>
        {initials}
      </div>
      <div className={`popup-wrapper ${showPopup ? "show" : ""}`}>
        <ProfilePopup />
      </div>
    </div>
  );
};

export default ProfileButton;
